import { type CategoryFacet } from "@/stf.data/schema";

import {
  type QueryParams,
  type Range,
} from "./typed";

interface RangeMapperProps {
  categoryAttribute: CategoryFacet[];
  categoryVariant: CategoryFacet[];
  fixedRange: {
    searchSlug: string;
    urlSlug: string;
  }[];
}

const rangeMapper = (props: RangeMapperProps) => {
  const {
    fixedRange,
    categoryVariant,
    categoryAttribute,
  } = props;

  return {
    createURL: (refinementList: Range): QueryParams => {
      const queryParams: QueryParams = {};

      if (!refinementList) {
        return queryParams;
      }

      categoryAttribute.forEach((c) => {
        if (c.facetType === "rangeSlider" && c.filterable) {
          const uiKey = `productAttributeDict.${c.label}`;
          const queryKey = `ar.${c.slug}`;

          const refinementValue = refinementList[uiKey];
          if (refinementValue) {
            queryParams[queryKey] = refinementValue;
          }
        }
      });
      categoryVariant.forEach((c) => {
        if (c.facetType === "rangeSlider" && c.filterable) {
          const uiKey = `variantSku.variantDisplay.${c.label}.meta.unitData.value`;
          const queryKey = `vr.${c.slug}`;

          const refinementValue = refinementList[uiKey];
          if (refinementValue) {
            queryParams[queryKey] = refinementValue;
          }
        }
      });

      fixedRange.forEach((r) => {
        const uiKey = r.searchSlug;
        const queryKey = `r.${r.urlSlug}`;

        const refinementValue = refinementList[uiKey];
        if (refinementValue) {
          queryParams[queryKey] = refinementValue;
        }
      });

      return queryParams;
    },
    parseURL: (queryParams: QueryParams | undefined): Range => {
      const refinementList: Range = {};

      if (!queryParams) {
        return undefined;
      }

      categoryAttribute.forEach((c) => {
        if (c.facetType === "rangeSlider" && c.filterable) {
          const uiKey = `productAttributeDict.${c.label}`;
          const queryKey = `ar.${c.slug}`;

          const refinementValue = queryParams[queryKey];
          if (refinementValue && typeof refinementValue === "string") {
            refinementList[uiKey] = refinementValue;
          }
        }
      });
      categoryVariant.forEach((c) => {
        if (c.facetType === "rangeSlider" && c.filterable) {
          const uiKey = `variantSku.variantDisplay.${c.label}.meta.unitData.value`;
          const queryKey = `vr.${c.slug}`;

          const refinementValue = queryParams[queryKey];
          if (refinementValue && typeof refinementValue === "string") {
            refinementList[uiKey] = refinementValue;
          }
        }
      });

      fixedRange.forEach((r) => {
        const uiKey = r.searchSlug;
        const queryKey = `r.${r.urlSlug}`;

        const refinementValue = queryParams[queryKey];
        if (refinementValue && typeof refinementValue === "string") {
          refinementList[uiKey] = refinementValue;
        }
      });

      if (Object.keys(refinementList).length === 0) {
        return undefined;
      }

      return refinementList;
    },
  };
};

export {
  rangeMapper,
};
